// src/js/modal.js

export function initModal() {
  const supportModal = document.getElementById("supportModal");
  const closeModal = document.getElementById("closeModal");
  const sliderTrack = document.querySelector('.slider-track');

  sliderTrack.addEventListener('click', (e) => {
    if (e.target.closest('.product-card')) {
      supportModal.classList.add("active");
    }
  });

  closeModal.addEventListener("click", () => {
    supportModal.classList.remove("active");
  });

  supportModal.addEventListener("click", (e) => {
    if (e.target === supportModal) {
      supportModal.classList.remove("active");
    }
  });
}
